import { css } from 'styled-components';
import { withUnit } from '../core/withUnit.js';

const width = css `
  width: ${props => withUnit(props.$width)};
`;

export { width };
//# sourceMappingURL=width.js.map
